import BetBarValueText from "slotworks/components/betbar/bet-bar-value-text";
import { Services } from "slotworks/services/services";
import gameiomModel from "gameiom/model/gameiom-model";

export default class AgsBetBarValueText extends BetBarValueText {

    public update(value: number) {
        super.update(value);
        if (this.currencyValueText) {
            if (value <= 0 && this.hideNillValue) {
                this.currencyValueText.setText("");
            } else {
                const trailingDecimals = (gameiomModel.currency === "TKN") ? false : true;
                this.currencyValueText.setText(Services.currency.format(value, trailingDecimals, false));
            }
        }
    }
};
